<template>
  <div class="audit-popup" v-loading="loading">
       <div class="default-modal">
    <el-dialog 
      v-model="innerVisible"
       class="existed-caseinfo-dialog"
       width="90%"
    >
     <div class="dialog-header">
            <span class="header-part">EXCEPTION REPORT </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="cancel"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>
       <div class="all-cases-view">
        <div class="popup-date">
      <div class="primary-content-view-new" v-loading="loading">
      <div class="listings listings__table listings__all-cases"
          id="all-cases-listings">
        <el-table style="width: 100%;max-height: 350px; overflow-y: auto;overflow-x: clip;" v-if="data && data.length" :data="data">
          <el-table-column label="Accession ID" prop="accession_id">
            <template #default="scope"> 
              <div class="name-accession">
                 <span id="accession-id" v-if="scope.row?.accession_id">
                {{ scope.row.accession_id }}
              </span>
               <span v-else>--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Insurance Name">
            <template #default="scope">
              <span v-if="scope.row?.billing_info?.insurance?.primary_insurance">
                {{ scope.row.billing_info.insurance.primary_insurance.payor }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Policy No">
            <template #default="scope">
              <span v-if="scope.row?.billing_info?.insurance?.primary_insurance">
                {{ scope.row.billing_info.insurance.primary_insurance.policy_id }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column min-width="110px" label="Exception Comments">
            <template #default="scope">
              <span v-if="scope.row?.billing_status_notes">
                {{ scope.row.billing_status_notes }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Case Type">
            <template #default="scope"> 
              <div class="case-type">
                <span class="case-data-type" v-if="scope.row?.case_types">
                {{ getCaseTypes(scope.row.case_types)[0]}}
                </span>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Date of Service">
            <template #default="scope">
              <span v-if="scope.row?.collection_date">
                {{
                  momentWithTimezone(
                    scope.row.collection_date,
                    "MM-DD-yyyy"
                  )
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Ordering Facility">
            <template #default="scope">
              <span v-if="scope.row?.facility_name">
                {{
                    scope.row.facility_name
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Patient DOB">
            <template #default="scope">
              <span v-if="scope.row?.patient_info?.date_of_birth">
                {{
                    formatDate(scope.row.patient_info.date_of_birth)
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Patient Name">
            <template #default="scope">
              <span v-if="scope.row?.patient_info">
                {{
                    convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Patient Gender">
            <template #default="scope">
              <span v-if="scope.row?.patient_info?.gender">
                {{
                    scope.row.patient_info.gender
                }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <p v-else>Data Not Found.</p>
      </div>
      </div>
        </div>
       </div>
      <!-- Actions -->
      <div class="dialog-actions">
        <el-button type="button" class="btn cancel-button" @click="cancel">Cancel</el-button>
        <el-button  type="button" class="btn save-button" @click="sendEmail" :disabled="!canSendEmail">Send Email</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
export default {
  name: "ExceptionPopup",
  props: {
    visible: { type: Boolean, required: true },
    facilityId: { type: String, required: true }, 
    emails: { type: Array, default: () => [] },
    managers: { type: Array, default: () => [] },
  },
  data() {
    return {
      innerVisible: this.visible,
      loading:false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  computed: {
    ...mapGetters("exceptionReport", [
      "getExceptionCases",
      "getExceptionCasesLoading",
      "getExceptionCasesError",
    ]),
    data() {
      if (!this.getExceptionCases) return [];
      const raw = this.getExceptionCases.data ?? this.getExceptionCases;
      if (Array.isArray(raw)) return raw;
      if (raw && typeof raw === "object") return Object.values(raw);
      return [];
    },
    canSendEmail() {
      // Enable only if data exists
      return this.data && this.data.length > 0;
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  methods: {
    ...mapActions("exceptionReport", ["sendExceptionCasesEmail"]),

    formatJSON(obj) {
      return JSON.stringify(obj, null, 2);
    },

     cancel() {
      this.innerVisible = false; 
      this.$emit("popup-closed", false); // notify parent
    },

    async sendEmail() {
      this.loading = true
      if (!this.emails.length) {
        this.$message.error("Please select at least one email.");
        return;
      }
      let combinedEMails = this.managers.concat(this.emails)
      const payload = {
        emails: combinedEMails, 
        facility_id: this.facilityId,
      };
      try {
        await this.sendExceptionCasesEmail(payload);
        this.$notify.success({
          title: "Success",
          message: "Email sent successfully",
        });
        this.innerVisible = false;
        this.$emit("popup-closed", true);
        this.loading = false
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Failed to send email.",
        });
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    visible(val) {
      this.innerVisible = val;
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
      if (!val) this.$emit("popup-closed"); // notify parent on close
    }
  },
};
</script>

<style lang="scss" scoped>
.audit-popup{
.dialog-actions {
  padding: 0 1rem 1rem 0;
  text-align: right;
 .el-button {
  border-radius: 5px;
  min-height: 32px;
  padding: 0 10px;
  font-weight: 500;
  transition: none !important; 
}
 .cancel-button {
  color: #273480 !important;
  border: 1px solid #dedbdb !important;
}
 .save-button {
  background-color: #273480 !important;
  color: #ffffff !important;
  border: none !important;
}
}
.dialog-actions .save-button:hover,
.dialog-actions .save-button:focus,
.dialog-actions .save-button:active {
  background-color: #273480 !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: none !important;
}
}

</style>